import Button from "@material-ui/core/Button";
import clsx from "clsx";
import React from "react";
import { logErr } from "../common";
import { buttonStyles } from "../styles";
import "../styles/globalStyles.css";

export const ButtonDefault = props => {
    const classes = buttonStyles();
    return (
        <Button
            className={clsx(
                classes.label,
                props.root,
                classes.primary,
                props.className
            )}
            variant={props.variant || "text"}
            disabled={props.disabled || false}
            disabledElevation={props.disabledElevation || false}
            disableFocusRipple={props.disableFocusRipple || false}
            endIcon={props.endIcon || false}
            fullWidth={props.fullWidth || false}
            href={props.href || ""}
            size={props.size || "medium"}
            startIcon={props.startIcon || ""}
            onClick={props.onClick || logErr()}
        >
            {props.children}
        </Button>
    );
};
